import Header from "../components/Header"
import HeroSection from "../components/HeroSection"
import ProductsSection from "../components/ProductsSection"
import InnovationSection from "../components/InnovationSection"
import FeatureSection from "../components/FeatureSection"
import TestimonialsSection from "../components/TestimonialsSection"
import CTASection from "../components/CTASection"
import Footer from "../components/Footer"

import "./HomePage.css"

export default function HomePage() {
  return (
    <main className="home-main">

      <Header />
      <HeroSection />
      <ProductsSection />
      <InnovationSection />
      <FeatureSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  )
}
